import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addDays from 'date-fns/add_days';
import subDays from 'date-fns/sub_days';
import subMonths from 'date-fns/sub_months';
import subYears from 'date-fns/sub_years';
import differenceInDays  from 'date-fns/difference_in_calendar_days'
import { status } from 'grpc';
import { getUserAll } from './core/cacheService';
export default {
    namespaced: true,
    state: {
        learningJourneys: [],
        learningJourneysLoading: false,
        overview:{active:0,completed:0,upskilling:0,learning_time:0},
        overviewAll:{active:0,completed:0,upskilling:0,learning_time:0},
        pieChart:null,
        barChart:null,
        datatable:[],
        datatableAll:{past_year:[],past_6_months:[],past_3_months:[],all_time:[]},
        status:{filter:'',team:'',search:''},
        period:'past_6_months',
        dataTeem:[],
        datatableSearch:[],
        datatablefilter:[],
        loading:true,
        snackbar:false
    },
    mutations: {
       
        setOverview(state: any, data: any) {
            state.overview = data
        },
        setOverviewAll(state: any, data: any) {
            state.overviewAll = data
        },
        setPieChart(state: any, data: any) {
            state.pieChart = data
        },
        setBarChart(state: any, data: any) {
            state.barChart = data
        },
        setDatatable(state: any, data: any) {
            state.datatable = data
        },
        setDatatableAll(state: any, data: any) {
            state.datatableAll = data
        },
        setPeriod(state: any, data: any) {
            state.period = data
        },
        setDataTeam(state: any, data: any) {
            state.dataTeam = data
        },
        setDatatableSearch(state: any, data: any) { 
            state.datatableSearch = data
        },
        setDatatableFilter(state: any, data: any) { 
            state.datatablefilter = data
        },
        setLoading(state: any, data: any) {
            state.loading = data
        },
        setStatus(state: any, data: any) {
            state.status = data
        },
        setSnackbar(state: any, data: any) {
            state.snackbar = data
        },
    },
    actions: {
        async getLearningJourneys({ rootState,commit,dispatch,state }: any) {
            //console.log('getLearningJourneys')
            commit('setLoading',true)
            const datatableAll=_.cloneDeep(state.datatableAll)
            await dispatch('main/getOrganization',rootState.authen.user.company,{root:true})
            let dataAll:any = []
            let completed:any = []
            let datatable:any = []
            let overview:any = {active:0,completed:0,upskilling:0,learning_time:0}
            let progress = 0
            let completed_page=0
            const uniqueMember:any=[]
            const pieChart:any = {manager:0,self:0}
            const past6Month = format(subMonths(new Date(), 6), 'YYYY-MM-DD')
            const newDate = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
            const barChart:any = []
            const user_all=await getUserAll(rootState.authen.user.company)//(await firebase.database().ref('users').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            if(state.period=='all_time'&&state.datatableAll.all_time.length==0){
                //console.log('all_time')
                await firebase.firestore().collection('develop_skills').where('company', '==', rootState.authen.user.company).get().then(async(querySnapshot) => {
                    console.log(`[Learning Journeys] Fetched ${querySnapshot.docs.length} documents from Firebase for all time`);
                    
                    if(querySnapshot.docs.length === 0) {
                        console.warn('[Learning Journeys] No documents found for this time period. Check date filters or company value.');
                    }
                    
                    querySnapshot.docs.map(async (doc: any) => {
                        const data = doc.data(); 
                        data.id=doc.id
                        if(data.review_id){
                            data.initiated_by ='manager'
                            
                        }else {
                            data.initiated_by ='self'
                            
                        }
                        const emailKey=data.email.replace(/\./g, '||');
                        data.team_id=user_all&&user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:''
                        dataAll.push(data)
                        // bar chart
                        if(!barChart[format(data.createdate,'YYYY-MM')]){
                                barChart[format(data.createdate,'YYYY-MM')] = {
                                            self:0,
                                            manager:0
                                }
                        }
                        barChart[format(data.createdate,'YYYY-MM')][data.initiated_by]++
                         // pie chart
                        if(data.initiated_by=='self'){
                            pieChart.self++
                        }else{
                            pieChart.manager++
                        }
                        // overview
                        if(data.finish){
                            overview.completed++
                            progress=100
    
                        }else{
                            overview.active++
                            progress=isNaN(Math.round((data.read+1)*100/data.qty))?0:Math.round((data.read+1)*100/data.qty)
                        }
                        if(data.read||data.read==0){
                            overview.learning_time+=(data.read+1)
                        }
                        const find_member=_.find(uniqueMember,['email',data.email])
                        if(!find_member){
                            uniqueMember.push({email:data.email})
                        }
                        // datatable
                        const firstname=user_all&&user_all[emailKey]&&user_all[emailKey].firstname?user_all[emailKey].firstname:''
                        const lastname=user_all&&user_all[emailKey]&&user_all[emailKey].lastname?user_all[emailKey].lastname:''
                        datatable.push({
                            id:data.id,
                            name:data.set_name,
                            createdate:format(data.createdate,'YYYY-MM'),
                            initiated:data.initiated_by=='self'?'Self':'Manager',
                            progress:Number(progress),
                            members:firstname +' '+lastname,
                            date:data.createdate,
                            pic:user_all[emailKey]&&user_all[emailKey].profilepic?user_all[emailKey].profilepic:'',
                            status:data.finish?'completed':'progress',
                            team:user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:'',
                            completed_page:data.read?data.read+1:1,
                            email:data.email,
                            response:data.response,
                            members_name:firstname +' '+lastname.charAt(0),
                            categoryTag: data.category_tag || 'Uncategorized'
                        })
                        
                        
                  
                    })
                    overview.upskilling=uniqueMember.length
                    datatableAll.all_time=datatable
                    //console.log('datatableAll',datatableAll.all_time)
                    await commit('setDatatableAll',datatableAll)
                        if(state.status.team!==''){
                            dispatch('changeTeam',state.status.team)
                        }else if(state.status.search!==''){
                            commit('setPieChart',pieChart)
                            commit('setBarChart',barChart)
                            commit('setOverview',overview) 
                            dispatch('searchdatatable',state.status.search)
                        }
                        else {
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        commit('setDatatable',datatable)
                        // Apply In Progress filter by default after setting the data
                        dispatch('filterStatus', 'In Progress')
                        }
             
                })


            }else if(state.period=='past_year'&&state.datatableAll.past_year.length==0){
                //console.log('past_year')
                const pastYear = format(subYears(new Date(), 1), 'YYYY-MM-DD')
                const endYear = format(new Date(), 'YYYY-MM-DD')
                //console.log('pastYear',pastYear)
                //console.log('endYear',endYear)
                await firebase.firestore().collection('develop_skills').where('company', '==', rootState.authen.user.company).where('createdate', '>=', pastYear).where('createdate', '<=', endYear).orderBy('createdate', 'desc').get().then(async(querySnapshot) => {
                    console.log(`[Learning Journeys] Fetched ${querySnapshot.docs.length} documents from Firebase for past year`);
                    
                    if(querySnapshot.docs.length === 0) {
                        console.warn('[Learning Journeys] No documents found for this time period. Check date filters or company value.');
                    }
                    
                    querySnapshot.docs.map(async (doc: any) => {
                        const data = doc.data(); 
                        data.id=doc.id
                        if(data.review_id){
                            data.initiated_by ='manager'
                            
                        }else {
                            data.initiated_by ='self'
                            
                        }
                        const emailKey=data.email.replace(/\./g, '||');
                        data.team_id=user_all&&user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:''
                        dataAll.push(data)
                        // bar chart
                        if(!barChart[format(data.createdate,'YYYY-MM')]){
                                barChart[format(data.createdate,'YYYY-MM')] = {
                                            self:0,
                                            manager:0
                                }
                        }
                        barChart[format(data.createdate,'YYYY-MM')][data.initiated_by]++
                         // pie chart
                        if(data.initiated_by=='self'){
                            pieChart.self++
                        }else{
                            pieChart.manager++
                        }
                        // overview
                        if(data.finish){
                            overview.completed++
                            progress=100
    
                        }else{
                            overview.active++
                            progress=isNaN(Math.round((data.read+1)*100/data.qty))?0:Math.round((data.read+1)*100/data.qty)
                        }
                        if(data.read||data.read==0){
                            overview.learning_time+=(data.read+1)
                        }
                        const find_member=_.find(uniqueMember,['email',data.email])
                        if(!find_member){
                            uniqueMember.push({email:data.email})
                        }
                        // datatable
                        const firstname=user_all&&user_all[emailKey]&&user_all[emailKey].firstname?user_all[emailKey].firstname:''
                        const lastname=user_all&&user_all[emailKey]&&user_all[emailKey].lastname?user_all[emailKey].lastname:''
                        datatable.push({
                            id:data.id,
                            name:data.set_name,
                            createdate:format(data.createdate,'YYYY-MM'),
                            initiated:data.initiated_by=='self'?'Self':'Manager',
                            progress:Number(progress),
                            members:firstname +' '+lastname,
                            date:data.createdate,
                            pic:user_all[emailKey]&&user_all[emailKey].profilepic?user_all[emailKey].profilepic:'',
                            status:data.finish?'completed':'progress',
                            team:user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:'',
                            completed_page:data.read?data.read+1:1,
                            email:data.email,
                            response:data.response,
                            members_name:firstname +' '+lastname.charAt(0),
                            categoryTag: data.category_tag || 'Uncategorized'
                        })
                        
                        
                  
                    })
                    overview.upskilling=uniqueMember.length
                    if(datatableAll.past_year.length==0){
                        datatableAll.past_year=datatable
                    }
                    
                    commit('setDatatableAll',datatableAll)
                    if(state.status.team!==''){
                        dispatch('changeTeam',state.status.team)
                    }else if(state.status.search!==''){
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        dispatch('searchdatatable',state.status.search)
                    }else {
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        commit('setDatatable',datatable)
                        // Apply In Progress filter by default after setting the data
                        dispatch('filterStatus', 'In Progress')
                    }
          
             
                })

            }else{
                await firebase.firestore().collection('develop_skills').where('company', '==', rootState.authen.user.company).where('createdate', '>=', past6Month).orderBy('createdate', 'desc').get().then(async(querySnapshot) => {
                    console.log(`[Learning Journeys] Fetched ${querySnapshot.docs.length} documents from Firebase for past 6 months (from ${past6Month})`);
                    
                    if(querySnapshot.docs.length === 0) {
                        console.warn('[Learning Journeys] No documents found for this time period. Check date filters or company value.');
                    }
                    
                    querySnapshot.docs.map(async (doc: any) => {
                        const data = doc.data(); 
                        data.id=doc.id
                        if(data.review_id){
                            data.initiated_by ='manager'
                            
                        }else {
                            data.initiated_by ='self'
                            
                        }
                        const emailKey=data.email.replace(/\./g, '||');
                        data.team_id=user_all&&user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:''
                        dataAll.push(data)
                        // bar chart
                        if(!barChart[format(data.createdate,'YYYY-MM')]){
                                barChart[format(data.createdate,'YYYY-MM')] = {
                                            self:0,
                                            manager:0
                                }
                        }
                        barChart[format(data.createdate,'YYYY-MM')][data.initiated_by]++
                         // pie chart
                        if(data.initiated_by=='self'){
                            pieChart.self++
                        }else{
                            pieChart.manager++
                        }
                        // overview
                        if(data.finish){
                            overview.completed++
                            progress=100
    
                        }else{
                            overview.active++
                            progress=isNaN(Math.round((data.read+1)*100/data.qty))?0:Math.round((data.read+1)*100/data.qty)
                        }
                        if(data.read||data.read==0){
                            overview.learning_time+=(data.read+1)
                        }
                        const find_member=_.find(uniqueMember,['email',data.email])
                        if(!find_member){
                            uniqueMember.push({email:data.email})
                        }
                        // datatable
                        const firstname=user_all&&user_all[emailKey]&&user_all[emailKey].firstname?user_all[emailKey].firstname:''
                        const lastname=user_all&&user_all[emailKey]&&user_all[emailKey].lastname?user_all[emailKey].lastname:''
                        datatable.push({
                            id:data.id,
                            name:data.set_name,
                            createdate:format(data.createdate,'YYYY-MM'),
                            initiated:data.initiated_by=='self'?'Self':'Manager',
                            progress:Number(progress),
                            members:firstname +' '+lastname,
                            members_name:firstname +' '+lastname.charAt(0),
                            date:data.createdate,
                            pic:user_all[emailKey]&&user_all[emailKey].profilepic?user_all[emailKey].profilepic:'',
                            status:data.finish?'completed':'progress',
                            team:user_all[emailKey]&&user_all[emailKey].team?user_all[emailKey].team:'',
                            completed_page:data.read?data.read+1:1,
                            email:data.email,
                            response:data.response,
                            categoryTag: data.category_tag || 'Uncategorized'
                        })
                        
                        
                  
                    })
                    overview.upskilling=uniqueMember.length
                    commit('setDatatableAll',{past_year:[],past_6_months:datatable,all_time:[]})
                    if(rootState.authen.user.user_type == 'leadership'&&state.status.team==''){
                        state.status.team=rootState.authen.user.team
                    }
                    if(state.status.team!==''){
                        dispatch('changeTeam',state.status.team)
                    }else if(state.status.search!==''){
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        dispatch('searchdatatable',state.status.search)
                    }else {
                        commit('setOverviewAll',overview)
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        commit('setDatatable',datatable)
                        // Apply In Progress filter by default after setting the data
                        dispatch('filterStatus', 'In Progress')
                    }
                   
                   
          
             
                })
            }
            commit('setLoading',false)
            

        },
       
        async searchdatatable({commit,state,dispatch},searchText: string){
            //console.log('data',searchText)
            let datatable:any=[]
            state.status.search=searchText
            if(state.status.filter!==''){
                datatable=state.datatablefilter
            }else if(state.status.team!==''){
                datatable=state.dataTeam
            }else{
                datatable=state.datatableAll[state.period]
            }
            //console.log('datatable',datatable)
            var re = new RegExp(searchText, 'gi')
            if (!searchText) {
                // ถ้าไม่มีข้อความค้นหา ให้แสดงข้อมูลทั้งหมด
                state.status.search=''
                if(state.status.filter!==''){
                    dispatch('filterStatus',state.status.filter)
                }else{
                    commit('setDatatable', datatable);
                }
                
                return;
            }

            
        
            
            var filtered = _.filter(datatable, (item): any => {
                if (item.name.match(re)) {
                    return true
                } else if (item.members.match(re)) {
                    return true
                } else if (item.initiated.match(re)) {
                    return true
                }else if (item.createdate.match(re)) {
                    return true
                }
            });
            
            commit('setDatatableSearch', filtered);
            commit('setDatatable', filtered);

        
        },
        async filterStatus({commit,state,dispatch},status: string){
            let datatable:any=[]
            state.status.filter=status
            if(state.status.search!==''){
                datatable=state.datatableSearch
            }else if(state.status.team!==''){
                datatable=state.dataTeam
            }else{
                datatable=state.datatableAll[state.period]
            }

            if(status=='All'){
                state.status.filter=''
                commit('setDatatable', datatable);
            }else{
                state.status.filter=status
                let filtered = []
                
                if(status === 'Not Started') {
                    filtered = datatable.filter((item: any) => {
                        return item.status === 'progress' && item.progress === 0;
                    });
                } else if(status === 'In Progress') {
                    filtered = datatable.filter((item: any) => {
                        return item.status === 'progress' && item.progress > 0;
                    });
                } else if(status === 'Completed') {
                    filtered = datatable.filter((item: any) => {
                        return item.status === 'completed';
                    });
                }
                
                commit('setDatatableFilter', filtered);
                commit('setDatatable', filtered);
                if(state.status.search!==''){
                    dispatch('searchdatatable',state.status.search)
                }
            }
        },
        async changeTeam({commit,state,rootState,dispatch},team: string){
            //console.log('team',team)
            let datatable:any=[]
            if(state.period=='all_time'){
                datatable=state.datatableAll.all_time
            }else if(state.period=='past_year'){
                datatable=state.datatableAll.past_year
            }else if(state.period=='past_6_months'){
                datatable=state.datatableAll.past_6_months
            }else if(state.period=='past_3_months'){
                datatable=state.datatableAll.past_3_months
            }
            
            //const datatable=state.datatableAll
            //console.log('datatable',datatable)

            let overview:any = {active:0,completed:0,upskilling:0,learning_time:0}
            const pieChart:any = {manager:0,self:0}
            const barChart:any = {}
            const uniqueMember:any=[]
            const datatable_new:any=[]
            const organization=rootState.main.organization
            //console.log('organization',organization)
            if(team!=='all'){
                state.status.team=team
                if(organization[team]){
                    for(const item in organization[team]){
                        //console.log('item',item)
                        const filtered = _.filter(datatable,(item_datatable) => {
                           
                            return item_datatable.team == item;
                        });
                        
                        if(filtered.length>0){
                            datatable_new.push(...filtered)
                            
                            for(const item_filtered of filtered){
                                overview.learning_time+=item_filtered.completed_page
                                if(item_filtered.status=='progress'){
                                    overview.active++
                                }else if(item_filtered.status=='completed'){
                                    overview.completed++
                                    const find_member=_.find(uniqueMember,['email',item_filtered.email])
                                    if(!find_member){
                                        uniqueMember.push({email:item_filtered.email})
                                    }
                                }
                                if(item_filtered.initiated=='Self'){
                                    pieChart.self++
                                    if(!barChart[item_filtered.createdate]){
                                        barChart[item_filtered.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item_filtered.createdate].self++
                                }else{
                                    pieChart.manager++
                                    if(!barChart[item_filtered.createdate]){
                                        barChart[item_filtered.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item_filtered.createdate].manager++
                                }
                            }
                        }
                    }
                    
                }else{
                    const filtered = _.filter(datatable,(item_datatable) => {
                       
                        return item_datatable.team == team;
                    });
                    if(filtered.length>0){
                        datatable_new.push(...filtered)
                        for(const item_filtered of filtered){
                            overview.learning_time+=item_filtered.completed_page
                            if(item_filtered.status=='progress'){
                                overview.active++
                            }else if(item_filtered.status=='completed'){
                                overview.completed++
                                const find_member=_.find(uniqueMember,['email',item_filtered.email])
                                if(!find_member){
                                    uniqueMember.push({email:item_filtered.email})
                                }
                            }
                            if(item_filtered.initiated=='Self'){
                                pieChart.self++
                                if(!barChart[item_filtered.createdate]){
                                    barChart[item_filtered.createdate] = {
                                        self:0,
                                        manager:0
                                    }
                                }
                                barChart[item_filtered.createdate].self++
                            }else{
                                pieChart.manager++
                                if(!barChart[item_filtered.createdate]){
                                    barChart[item_filtered.createdate] = {
                                        self:0,
                                        manager:0
                                    }
                                }
                                barChart[item_filtered.createdate].manager++
                            }
                        }
                    }
                }
                overview.upskilling=uniqueMember.length
                commit('setDataTeam',datatable_new)
                if(state.status.search!==''){
                    dispatch('searchdatatable',state.status.search)
                }else if(state.status.filter!==''){
                    dispatch('filterStatus',state.status.filter)
                }else{
                    commit('setDatatable', datatable_new);
                    // console.log('datatable_new',datatable_new)
                }
    
                commit('setOverview',overview)
                commit('setPieChart',pieChart)
                commit('setBarChart',barChart)
                
                

            }else{
                state.status.team=''
                const datatable_new:any=[]
                    for(const item of datatable){
                     
                        
                            datatable_new.push(item)
                                overview.learning_time+=item.completed_page
                                    if(item.status=='progress'){
                                        overview.active++
                                    }else if(item.status=='completed'){
                                        overview.completed++
                                        const find_member=_.find(uniqueMember,['email',item.email])
                                        if(!find_member){
                                            uniqueMember.push({email:item.email})
                                        }
                                    }
                                    if(item.initiated=='Self'){
                                        pieChart.self++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].self++
                                    }else{
                                        pieChart.manager++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].manager++
                                    }

                        
                    }
                   
                        commit('setDatatable', datatable_new);
                        commit('setOverview',overview)
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)   
            }
        },
        async filterPeriod({commit,state,dispatch},period: string){
            // console.log('period',period)
            
            let overview:any = {active:0,completed:0,upskilling:0,learning_time:0}
            const pieChart:any = {manager:0,self:0}
            const barChart:any = {}
            const uniqueMember:any=[]
            if(period=='All-time'){
                
                commit('setPeriod','all_time')
                if(state.datatableAll.all_time.length==0){
                    
                    await dispatch('getLearningJourneys','all_time')
                }else{
                    const datatable=state.datatableAll.all_time
                    const datatable_new:any=[]
                    for(const item of datatable){
                        //console.log('item',format(subMonths(new Date(), 2), 'YYYY-MM-01'))
                        
                            datatable_new.push(item)
                                overview.learning_time+=item.completed_page
                                    if(item.status=='progress'){
                                        overview.active++
                                    }else if(item.status=='completed'){
                                        overview.completed++
                                        const find_member=_.find(uniqueMember,['email',item.email])
                                        if(!find_member){
                                            uniqueMember.push({email:item.email})
                                        }
                                    }
                                    if(item.initiated=='Self'){
                                        pieChart.self++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].self++
                                    }else{
                                        pieChart.manager++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].manager++
                                    }

                        
                    }
                    if(state.status.team!==''){
                        dispatch('changeTeam',state.status.team)
                    }else if(state.status.search!==''){
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        dispatch('searchdatatable',state.status.search)
                    }else {
                        commit('setDatatable', datatable_new);
                        commit('setOverview',overview)
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)

                    }
                    
                }
                
            }else if(period=='Past 6-months'){
                commit('setPeriod','past_6_months')
                const datatable=state.datatableAll.past_6_months
                const datatable_new:any=[]
                for(const item of datatable){
                    //console.log('item',format(subMonths(new Date(), 2), 'YYYY-MM-01'))
                    
                        datatable_new.push(item)
                            overview.learning_time+=item.completed_page
                                if(item.status=='progress'){
                                    overview.active++
                                }else if(item.status=='completed'){
                                    overview.completed++
                                    const find_member=_.find(uniqueMember,['email',item.email])
                                    if(!find_member){
                                        uniqueMember.push({email:item.email})
                                    }
                                }
                                if(item.initiated=='Self'){
                                    pieChart.self++
                                    if(!barChart[item.createdate]){
                                        barChart[item.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item.createdate].self++
                                }else{
                                    pieChart.manager++
                                    if(!barChart[item.createdate]){
                                        barChart[item.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item.createdate].manager++
                                }

                    
                }
                if(state.status.team!==''){
                    dispatch('changeTeam',state.status.team)
                }else if(state.status.search!==''){
                    commit('setPieChart',pieChart)
                    commit('setBarChart',barChart)
                    commit('setOverview',overview) 
                    dispatch('searchdatatable',state.status.search)
                }else {
                    commit('setDatatable', datatable_new);
                    commit('setOverview',overview)
                    commit('setPieChart',pieChart)
                    commit('setBarChart',barChart)

                }

            }else if(period=='Past 3-months'){
                let datatableAll=state.datatableAll
                const datatable=state.datatableAll.past_6_months
                const datatable_new:any=[]
                for(const item of datatable){
                    //console.log('item',format(subMonths(new Date(), 2), 'YYYY-MM-01'))
                    if(item.date>=format(subMonths(new Date(), 3), 'YYYY-MM-DD')){
                        datatable_new.push(item)
                            overview.learning_time+=item.completed_page
                                if(item.status=='progress'){
                                    overview.active++
                                }else if(item.status=='completed'){
                                    overview.completed++
                                    const find_member=_.find(uniqueMember,['email',item.email])
                                    if(!find_member){
                                        uniqueMember.push({email:item.email})
                                    }
                                }
                                if(item.initiated=='Self'){
                                    pieChart.self++
                                    if(!barChart[item.createdate]){
                                        barChart[item.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item.createdate].self++
                                }else{
                                    pieChart.manager++
                                    if(!barChart[item.createdate]){
                                        barChart[item.createdate] = {
                                            self:0,
                                            manager:0
                                        }
                                    }
                                    barChart[item.createdate].manager++
                                }

                    }
                }
                datatableAll.past_3_months=datatable_new
                    commit('setDatatableAll',datatableAll)
                if(state.status.team!==''){
                    dispatch('changeTeam',state.status.team)
                }else if(state.status.search!==''){
                    commit('setPieChart',pieChart)
                    commit('setBarChart',barChart)
                    commit('setOverview',overview) 
                    dispatch('searchdatatable',state.status.search)
                }else {
                    commit('setDatatable', datatable_new);
                    commit('setOverview',overview)
                    commit('setPieChart',pieChart)
                    commit('setBarChart',barChart)

                }
                

            }else if(period=='Past year'){
                commit('setPeriod','past_year')
                if(state.datatableAll.past_year.length==0){
                    await dispatch('getLearningJourneys','past_year')
                }else{
                    const datatable=state.datatableAll.past_year
                    const datatable_new:any=[]
                    for(const item of datatable){
                        //console.log('item',format(subMonths(new Date(), 2), 'YYYY-MM-01'))
                        
                            datatable_new.push(item)
                                overview.learning_time+=item.completed_page
                                    if(item.status=='progress'){
                                        overview.active++
                                    }else if(item.status=='completed'){
                                        overview.completed++
                                        const find_member=_.find(uniqueMember,['email',item.email])
                                        if(!find_member){
                                            uniqueMember.push({email:item.email})
                                        }
                                    }
                                    if(item.initiated=='Self'){
                                        pieChart.self++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].self++
                                    }else{
                                        pieChart.manager++
                                        if(!barChart[item.createdate]){
                                            barChart[item.createdate] = {
                                                self:0,
                                                manager:0
                                            }
                                        }
                                        barChart[item.createdate].manager++
                                    }

                        
                    }
                    if(state.status.team!==''){
                        dispatch('changeTeam',state.status.team)
                    }else if(state.status.search!==''){
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                        commit('setOverview',overview) 
                        dispatch('searchdatatable',state.status.search)
                    }else {
                        commit('setDatatable', datatable_new);
                        commit('setOverview',overview)
                        commit('setPieChart',pieChart)
                        commit('setBarChart',barChart)
                    }
                }
                
            }
            
            
        },
        async filterByCategory({ commit, state }, category: string) {
            const status = state.status;
            let filteredData = [];
            
            // Get the correct data based on the current period
            const sourceData = state.datatableAll[state.period];
            
            if (category === 'All') {
                filteredData = sourceData;
            } else {
                filteredData = sourceData.filter((item: any) => item.categoryTag === category);
            }
            
            // Apply existing status filter if any
            if (status.filter) {
                const statusMap: any = {
                    'Not Started': (item: any) => item.progress === 0,
                    'In Progress': (item: any) => item.progress > 0 && item.progress < 100,
                    'Completed': (item: any) => item.progress === 100
                };
                
                filteredData = filteredData.filter(statusMap[status.filter] || (() => true));
            }
            
            // Apply existing search filter if any
            if (status.search) {
                const searchLower = status.search.toLowerCase();
                filteredData = filteredData.filter((item: any) => 
                    item.name.toLowerCase().includes(searchLower) ||
                    item.members.toLowerCase().includes(searchLower)
                );
            }
            
            commit('setDatatable', filteredData);
        },
        async getDataExportCategoryAnalytics({ commit, dispatch, state, getters }: any) {
            commit('setSnackbar', true);
            // Small delay to ensure UI updates
            setTimeout(() => {
                dispatch('genDataExportCategoryAnalytics');
            }, 100);
        },
        async genDataExportCategoryAnalytics({ commit, state, getters, rootState }: any) {
            try {
                const Excel = require('exceljs');
                const wb = new Excel.Workbook();
                const ws = wb.addWorksheet('Category Analytics');
                const ws2 = wb.addWorksheet('Individual Learning Journeys');
                const ws3 = wb.addWorksheet('Learning Leaderboard');

                // Get the category analytics data from getters
                const categoryData = getters.categoryAnalytics || [];
                const overview = state.overview || {};
                
                // Title
                ws.mergeCells('A1', 'H1');
                ws.getRow(1).height = 30;
                ws.getCell('A1').font = { name: 'Arial', size: 18, bold: true };
                ws.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
                // Get the time period from the component
                const timePeriod = rootState.learningJourneys.period;
                const timePeriodMap: any = {
                    'all_time': 'All-time',
                    'past_year': 'Past year',
                    'past_6_months': 'Past 6-months',
                    'past_3_months': 'Past 3-months'
                };
                ws.getCell('A1').value = `Learning Journey Category Analytics - ${timePeriodMap[timePeriod] || 'Past 6-months'}`;

                // Export date
                ws.getCell('A2').value = `Export Date: ${format(new Date(), 'MMM DD, YYYY HH:mm')}`;
                ws.getCell('A2').font = { name: 'Arial', size: 10, italic: true };

                // Summary section
                ws.getRow(4).font = { bold: true };
                ws.getCell('A4').value = 'Summary';
                
                ws.getCell('A5').value = 'Total Categories:';
                ws.getCell('B5').value = categoryData.length;
                
                ws.getCell('A6').value = 'Total Journeys:';
                ws.getCell('B6').value = categoryData.reduce((total: number, cat: any) => total + cat.count, 0);
                
                ws.getCell('A7').value = 'Active Journeys:';
                ws.getCell('B7').value = categoryData.reduce((total: number, cat: any) => total + cat.active, 0);
                
                ws.getCell('A8').value = 'Completed Journeys:';
                ws.getCell('B8').value = categoryData.reduce((total: number, cat: any) => total + cat.completed, 0);
                
                ws.getCell('A9').value = 'Total Learning Time:';
                ws.getCell('B9').value = `${(overview.learning_time * 15).toLocaleString()} minutes`;

                // Category details header
                ws.getRow(11).font = { bold: true };
                ws.getCell('A11').value = 'Category Details';

                // Table headers
                const headers = ['Category', 'Total Journeys', 'Active', 'Completed', '% of Total', 'Manager-Initiated', 'Self-Initiated', 'Learning Time (min)'];
                const headerRow = ws.getRow(12);
                headerRow.font = { bold: true };
                headerRow.height = 20;
                headers.forEach((header, index) => {
                    const cell = headerRow.getCell(index + 1);
                    cell.value = header;
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFE6E6E6' }
                    };
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                });

                // Category data rows
                const totalJourneys = categoryData.reduce((total: number, cat: any) => total + (cat && cat.count ? cat.count : 0), 0) || 1;
                let currentRow = 13;
                
                if (categoryData.length === 0) {
                    // Add a row indicating no data
                    const row = ws.getRow(currentRow);
                    row.getCell(1).value = 'No category data available for the selected time period';
                    ws.mergeCells(`A${currentRow}`, `H${currentRow}`);
                    row.getCell(1).alignment = { horizontal: 'center' };
                    row.getCell(1).font = { italic: true, color: { argb: 'FF666666' } };
                    currentRow++;
                }
                
                categoryData.forEach((category: any) => {
                    const row = ws.getRow(currentRow);
                    
                    // Calculate manager vs self-initiated for this category and learning time
                    let managerCount = 0;
                    let selfCount = 0;
                    let categoryLearningTime = 0;
                    
                    // Get the raw data to calculate manager/self breakdown and learning time
                    let rawData: any[] = [];
                    if (state.status.team !== '' && state.dataTeam) {
                        rawData = state.dataTeam;
                    } else if (state.datatableAll[state.period]) {
                        rawData = state.datatableAll[state.period];
                    }
                    
                    rawData.forEach((journey: any) => {
                        if (journey.categoryTag === category.category) {
                            if (journey.initiated === 'Manager') {
                                managerCount++;
                            } else {
                                selfCount++;
                            }
                            categoryLearningTime += (journey.completed_page || 0);
                        }
                    });
                    
                    row.getCell(1).value = category.category;
                    row.getCell(2).value = category.count;
                    row.getCell(3).value = category.active;
                    row.getCell(4).value = category.completed;
                    row.getCell(5).value = parseFloat(((category.count / totalJourneys) * 100).toFixed(1));
                    row.getCell(6).value = managerCount;
                    row.getCell(7).value = selfCount;
                    row.getCell(8).value = categoryLearningTime * 15; // Convert pages to minutes
                    
                    // Add borders to data cells
                    for (let i = 1; i <= 8; i++) {
                        row.getCell(i).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                    
                    currentRow++;
                });

                // Set column widths
                ws.columns = [
                    { width: 25 },  // Category
                    { width: 15 },  // Total Journeys
                    { width: 10 },  // Active
                    { width: 12 },  // Completed
                    { width: 12 },  // % of Total
                    { width: 18 },  // Manager-Initiated
                    { width: 15 },  // Self-Initiated
                    { width: 18 }   // Learning Time (min)
                ];

                // Individual Learning Journeys Tab
                // Title
                ws2.mergeCells('A1', 'H1');
                ws2.getRow(1).height = 30;
                ws2.getCell('A1').font = { name: 'Arial', size: 18, bold: true };
                ws2.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
                ws2.getCell('A1').value = `Individual Learning Journeys - ${timePeriodMap[timePeriod] || 'Past 6-months'}`;

                // Export date
                ws2.getCell('A2').value = `Export Date: ${format(new Date(), 'MMM DD, YYYY HH:mm')}`;
                ws2.getCell('A2').font = { name: 'Arial', size: 10, italic: true };

                // Headers for individual journeys
                const journeyHeaders = ['Name', 'Email Address', 'Team Name', 'Source', 'Learning Journey', 'Category', 'Progress (%)', 'Learning Time (min)'];
                const journeyHeaderRow = ws2.getRow(4);
                journeyHeaderRow.font = { bold: true };
                journeyHeaderRow.height = 20;
                journeyHeaders.forEach((header, index) => {
                    const cell = journeyHeaderRow.getCell(index + 1);
                    cell.value = header;
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFE6E6E6' }
                    };
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                });

                // Get individual journey data
                let journeyData: any[] = [];
                if (state.status.team !== '' && state.dataTeam) {
                    journeyData = state.dataTeam;
                } else if (state.datatableAll[state.period]) {
                    journeyData = state.datatableAll[state.period];
                }

                // Get teams mapping to resolve team names
                const teamsMapping = rootState.team && rootState.team.teamsfixedall_temp ? rootState.team.teamsfixedall_temp : {};
                
                // Sort by name then by learning journey name
                journeyData.sort((a: any, b: any) => {
                    const nameCompare = a.members.localeCompare(b.members);
                    if (nameCompare !== 0) return nameCompare;
                    return a.name.localeCompare(b.name);
                });

                // Add journey data rows
                let journeyRow = 5;
                journeyData.forEach((journey: any) => {
                    const row = ws2.getRow(journeyRow);
                    
                    // Resolve team name from team ID
                    let teamName = 'N/A';
                    if (journey.team && teamsMapping[journey.team]) {
                        teamName = teamsMapping[journey.team].name || journey.team;
                    } else if (journey.team) {
                        teamName = journey.team;
                    }
                    
                    row.getCell(1).value = journey.members;
                    row.getCell(2).value = journey.email;
                    row.getCell(3).value = teamName;
                    row.getCell(4).value = journey.initiated;
                    row.getCell(5).value = journey.name;
                    row.getCell(6).value = journey.categoryTag || 'Uncategorized';
                    row.getCell(7).value = journey.progress;
                    row.getCell(8).value = (journey.completed_page || 0) * 15;
                    
                    // Add borders to data cells
                    for (let i = 1; i <= 8; i++) {
                        row.getCell(i).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                    
                    journeyRow++;
                });

                // Set column widths for journeys sheet
                ws2.columns = [
                    { width: 25 },  // Name
                    { width: 30 },  // Email Address
                    { width: 20 },  // Team Name
                    { width: 12 },  // Source
                    { width: 40 },  // Learning Journey
                    { width: 20 },  // Category
                    { width: 15 },  // Progress (%)
                    { width: 20 }   // Learning Time (min)
                ];

                // Learning Leaderboard Tab
                // Title
                ws3.mergeCells('A1', 'J1');
                ws3.getRow(1).height = 30;
                ws3.getCell('A1').font = { name: 'Arial', size: 18, bold: true };
                ws3.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' };
                ws3.getCell('A1').value = `Learning Leaderboard - ${timePeriodMap[timePeriod] || 'Past 6-months'}`;

                // Export date
                ws3.getCell('A2').value = `Export Date: ${format(new Date(), 'MMM DD, YYYY HH:mm')}`;
                ws3.getCell('A2').font = { name: 'Arial', size: 10, italic: true };

                // Calculate leaderboard metrics
                const leaderboardData: Record<string, any> = {};
                
                journeyData.forEach((journey: any) => {
                    const email = journey.email;
                    if (!leaderboardData[email]) {
                        leaderboardData[email] = {
                            name: journey.members,
                            email: email,
                            team: journey.team,
                            totalJourneys: 0,
                            completedJourneys: 0,
                            inProgressJourneys: 0,
                            totalProgress: 0,
                            categories: new Set(),
                            managerInitiated: 0,
                            selfInitiated: 0,
                            totalLearningPages: 0
                        };
                    }
                    
                    leaderboardData[email].totalJourneys++;
                    leaderboardData[email].totalProgress += journey.progress;
                    leaderboardData[email].categories.add(journey.categoryTag || 'Uncategorized');
                    leaderboardData[email].totalLearningPages += (journey.completed_page || 0);
                    
                    if (journey.status === 'completed') {
                        leaderboardData[email].completedJourneys++;
                    } else {
                        leaderboardData[email].inProgressJourneys++;
                    }
                    
                    if (journey.initiated === 'Manager') {
                        leaderboardData[email].managerInitiated++;
                    } else {
                        leaderboardData[email].selfInitiated++;
                    }
                });

                // Convert to array and calculate additional metrics
                const leaderboardArray = Object.values(leaderboardData).map((learner: any) => ({
                    ...learner,
                    avgProgress: Math.round(learner.totalProgress / learner.totalJourneys),
                    completionRate: Math.round((learner.completedJourneys / learner.totalJourneys) * 100),
                    categoriesCount: learner.categories.size,
                    engagementScore: (learner.totalJourneys * 10) + (learner.completedJourneys * 20) + (learner.selfInitiated * 5)
                }));

                // Sort by engagement score (can be customized)
                leaderboardArray.sort((a: any, b: any) => b.engagementScore - a.engagementScore);

                // Headers for leaderboard
                const leaderboardHeaders = [
                    'Rank', 'Name', 'Email', 'Team', 'Total Journeys', 
                    'Completed', 'In Progress', 'Completion Rate %', 
                    'Avg Progress %', 'Learning Time (min)'
                ];
                const leaderboardHeaderRow = ws3.getRow(4);
                leaderboardHeaderRow.font = { bold: true };
                leaderboardHeaderRow.height = 20;
                leaderboardHeaders.forEach((header, index) => {
                    const cell = leaderboardHeaderRow.getCell(index + 1);
                    cell.value = header;
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFE6E6E6' }
                    };
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                });

                // Add leaderboard data rows
                let leaderboardRow = 5;
                leaderboardArray.forEach((learner: any, index: number) => {
                    const row = ws3.getRow(leaderboardRow);
                    
                    // Resolve team name
                    let teamName = 'N/A';
                    if (learner.team && teamsMapping[learner.team]) {
                        teamName = teamsMapping[learner.team].name || learner.team;
                    } else if (learner.team) {
                        teamName = learner.team;
                    }
                    
                    row.getCell(1).value = index + 1;
                    row.getCell(2).value = learner.name;
                    row.getCell(3).value = learner.email;
                    row.getCell(4).value = teamName;
                    row.getCell(5).value = learner.totalJourneys;
                    row.getCell(6).value = learner.completedJourneys;
                    row.getCell(7).value = learner.inProgressJourneys;
                    row.getCell(8).value = learner.completionRate;
                    row.getCell(9).value = learner.avgProgress;
                    row.getCell(10).value = learner.totalLearningPages * 15;
                    
                    // Add borders and special formatting for top 3
                    for (let i = 1; i <= 10; i++) {
                        row.getCell(i).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                        
                        // Highlight top 3 learners
                        if (index < 3) {
                            row.getCell(i).fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: { 
                                    argb: index === 0 ? 'FFFFD700' : // Gold
                                          index === 1 ? 'FFC0C0C0' : // Silver
                                          'FFCD7F32'   // Bronze
                                }
                            };
                        }
                    }
                    
                    leaderboardRow++;
                });

                // Add summary section
                const summaryStartRow = leaderboardRow + 2;
                ws3.getRow(summaryStartRow).font = { bold: true };
                ws3.getCell(`A${summaryStartRow}`).value = 'Summary Statistics';
                
                ws3.getCell(`A${summaryStartRow + 1}`).value = 'Total Active Learners:';
                ws3.getCell(`B${summaryStartRow + 1}`).value = leaderboardArray.length;
                
                ws3.getCell(`A${summaryStartRow + 2}`).value = 'Total Learning Journeys:';
                ws3.getCell(`B${summaryStartRow + 2}`).value = journeyData.length;
                
                ws3.getCell(`A${summaryStartRow + 3}`).value = 'Average Journeys per Learner:';
                ws3.getCell(`B${summaryStartRow + 3}`).value = leaderboardArray.length > 0 ? 
                    (journeyData.length / leaderboardArray.length).toFixed(1) : 0;

                // Set column widths for leaderboard sheet
                ws3.columns = [
                    { width: 8 },   // Rank
                    { width: 25 },  // Name
                    { width: 30 },  // Email
                    { width: 20 },  // Team
                    { width: 15 },  // Total Journeys
                    { width: 12 },  // Completed
                    { width: 12 },  // In Progress
                    { width: 18 },  // Completion Rate %
                    { width: 15 },  // Avg Progress %
                    { width: 20 }   // Learning Time (min)
                ];

                // Generate file
                const buffer = await wb.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Learning_Journey_Category_Analytics_${format(new Date(), 'YYYY_MM_DD')}.xlsx`;
                a.click();
                window.URL.revokeObjectURL(url);
                
                // Hide loading
                setTimeout(() => {
                    commit('setSnackbar', false);
                }, 500);
                
            } catch (error) {
                console.error('Error generating export:', error);
                commit('setSnackbar', false);
            }
        },
    },
    getters: {
        learningJourneys: (state: any) => state.learningJourneys,
        overview: (state: any) => state.overview,
        pieChart: (state: any) => state.pieChart,
        barChart: (state: any) => state.barChart,
        datatable: (state: any) => state.datatable,
        loading: (state: any) => state.loading,
        snackbar: (state: any) => state.snackbar,
        topLearners: (state: any) => {
            // Get data based only on team and time period filters
            let data: any[] = [];
            if (state.status.team !== '' && state.dataTeam) {
                // If team is selected, use team data
                data = state.dataTeam;
            } else if (state.datatableAll[state.period]) {
                // Otherwise use all data for the selected time period
                data = state.datatableAll[state.period];
            }
            
            // Count journeys per user
            const counts: Record<string, {email: string, name: string, pic: string, count: number}> = {};
            data.forEach((journey: any) => {
                const email = journey.email;
                if (!counts[email]) {
                    counts[email] = {
                        email: email,
                        name: journey.members,
                        pic: journey.pic,
                        count: 0
                    };
                }
                counts[email].count++;
            });
            
            // Convert to array and sort by count descending
            const result = Object.values(counts)
                .sort((a: {count: number}, b: {count: number}) => b.count - a.count);
                
            return result;
        },
        topSixLearners: (state: any, getters: any) => {
            // Return only the top 6 learners for the compact view
            return getters.topLearners.slice(0, 6);
        },
        categoryAnalytics: (state: any) => {
            // Get data based on filters
            let data: any[] = [];
            if (state.status.team !== '' && state.dataTeam) {
                data = state.dataTeam;
            } else if (state.datatableAll[state.period]) {
                data = state.datatableAll[state.period];
            }
            // Count journeys per category
            const categoryCounts: Record<string, {category: string, count: number, active: number, completed: number}> = {};
            data.forEach((journey: any) => {
                const category = journey.categoryTag || 'Uncategorized';
                if (category === 'Uncategorized') return; // Exclude Uncategorized
                if (!categoryCounts[category]) {
                    categoryCounts[category] = {
                        category: category,
                        count: 0,
                        active: 0,
                        completed: 0
                    };
                }
                categoryCounts[category].count++;
                if (journey.status === 'completed') {
                    categoryCounts[category].completed++;
                } else {
                    categoryCounts[category].active++;
                }
            });
            // Convert to array and sort by count descending
            const result = Object.values(categoryCounts)
                .sort((a: {count: number}, b: {count: number}) => b.count - a.count);
            return result;
        },
        topSixCategories: (state: any, getters: any) => {
            // Return only the top 6 categories for the compact view
            return getters.categoryAnalytics.slice(0, 6);
        }
    }
}
